import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import { Autocomplete, Button, FormControl, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import {
  EnterpriseAdd,
  EnterpriseEdit,
  getEnterprise,
} from "../../adapter/EnterpriseAdapter";
import GoBack from "../../components/GoBack";
import Loader from "../../components/Loader";

export default function EnterpriseSave() {
  const enterpriseLocation = useLocation().state;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(
    enterpriseLocation ? enterpriseLocation[0]?.id : ""
  );
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: enterpriseLocation ? enterpriseLocation[0]?.name : "",
      natureOfDispute: enterpriseLocation
        ? enterpriseLocation[0]?.natureOfDispute
        : "",
      complexity: enterpriseLocation ? enterpriseLocation[0]?.complexity : "",
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      const enterpriseId = enterpriseLocation?.enterpriseId;

      if (enterpriseId) {
        setId(enterpriseId);
        setLoading(true);

        try {
          const enterprise = await getEnterprise(enterpriseId);
          const { name, natureOfDispute, complexity } = enterprise;

          // Set default values for the form fields
          setValue("name", name);
          setValue("natureOfDispute", natureOfDispute);

          // Manually set default values for Autocomplete fields
          setValue("complexity", { label: complexity, value: complexity });

          setLoading(false);
        } catch (error) {
          console.error("Error fetching enterprise data:", error);
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [enterpriseLocation, setValue]);

  const onSubmit = async (value) => {
    setLoading(true);

    try {
      if (id) {
        const result = await EnterpriseEdit(id, value);
        handleSubmissionResult(result);
        setLoading(false);
      } else {
        const result = await EnterpriseAdd(value);
        handleSubmissionResult(result);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting enterprise data:", error);
      setLoading(false);
    }
  };

  const handleSubmissionResult = (result) => {
    console.log(result.status);
    if (result.status === "success") {
      navigate("/app/enterprises");
      console.log(result);
      toast.success(result.message);
    } else {
      toast.error(result.message);
      reset();
    }
  };

  return (
    <div className="navView">
      <ToastContainer />
      <Loader loading={loading} />
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="component-title">Create Enterprise</h2>
          <GoBack />
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formStyle">
            <div className="formItem">
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Enterprise Name"
                  variant="outlined"
                  type="text"
                  name="name"
                  {...register("name", {
                    required: {
                      value: true,
                      message: "Enterprise Name is required!",
                    },
                  })}
                  error={Boolean(errors.name)}
                  helperText={errors.name?.message}
                  disabled={loading}
                />
              </FormControl>
            </div>
            <div className="formItem">
              <FormControl fullWidth>
                <Autocomplete
                  options={[
                    "OTHERS",
                    "UNSECURED_LOAN",
                    "LAP",
                    "ASSET_BASED_FINANCE",
                    "CREDIT_CARD",
                    "BUSINESS_DISPUTE",
                    "HIGH_COURT_DISPUTE",
                  ]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      id="outlined-basic"
                      label="Nature of Dispute"
                      variant="outlined"
                      type="text"
                      name="natureOfDispute"
                      {...register("natureOfDispute", {})}
                      error={Boolean(errors.natureOfDispute)}
                      helperText={errors.natureOfDispute?.message}
                      disabled={loading}
                    />
                  )}
                />
              </FormControl>
            </div>
            <div className="formItem">
              <FormControl fullWidth>
                <Autocomplete
                  options={[
                    "ELEMENTARY",
                    "SIMPLE",
                    "STRAIGHTFORWARD",
                    "ELABORATE",
                    "INTRICATE",
                    "COMPLEX",
                  ]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      id="outlined-basic"
                      label="complexity"
                      variant="outlined"
                      type="text"
                      name="complexity"
                      {...register("complexity", {})}
                      error={Boolean(errors.complexity)}
                      helperText={errors.complexity?.message}
                      disabled={loading}
                    />
                  )}
                  getOptionSelected={(option, value) =>
                    option.value === value.value
                  }
                />
              </FormControl>
            </div>
          </div>
          <div className="formButtons-block">
            <Button
              startIcon={<SaveIcon />}
              disabled={loading}
              className={loading ? "prev" : ""}
              type="submit"
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
            >
              {id ? "Update" : "Save"}
            </Button>
            <Button
              startIcon={<RotateLeftIcon />}
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
              onClick={() => reset()}
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
            >
              Reset
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
